// extracted by mini-css-extract-plugin
export default {"wrap":"Ir-z","fullWidth":"Jr-z","items":"Kr-z","featureCss":"Lr-z","disabled":"Mr-z","imgCss":"Nr-z"};